'use client';

import { useEffect } from 'react';

export const OVERLAY_PORTAL_ATTR = 'data-overlay-portal';

/**
 * Marks every direct child of `<body>` as `inert` except the overlay portal root.
 * The overlay is portaled to `document.body` with `data-overlay-portal` so it stays
 * interactive while the rest of the page (navbar, main, etc.) is inert.
 */
export function useInertBackground(active: boolean): void {
  useEffect(() => {
    if (!active) return;

    const inerted: HTMLElement[] = [];

    for (const child of document.body.children) {
      if (!(child instanceof HTMLElement)) continue;
      if (child.hasAttribute(OVERLAY_PORTAL_ATTR)) continue;
      if (child.inert) continue;

      child.inert = true;
      inerted.push(child);
    }

    return () => {
      for (const element of inerted) {
        element.inert = false;
      }
    };
  }, [active]);
}
